import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Box from "@mui/material/Box";
import zIndex from "@mui/material/styles/zIndex";
import { useRef, useState, useLayoutEffect } from "react";

const SortableItem = ({
  id,
  children,
  disabled = false,
}: {
  id: string;
  children: React.ReactNode;
  disabled?: boolean;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled,
  });

  const nodeRef = useRef<HTMLDivElement | null>(null);
  const [dims, setDims] = useState<{ width: number; height: number }>();

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
    zIndex: isDragging ? zIndex.snackbar : "auto",
    height: isDragging && dims ? dims.height : undefined,
    width: isDragging && dims ? dims.width : undefined,
  };

  useLayoutEffect(() => {
    if (nodeRef.current) {
      const { offsetWidth: width, offsetHeight: height } = nodeRef.current;
      setDims({ width, height });
    }
  }, []);

  return (
    <Box
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      sx={{
        touchAction: "manipulation",
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        WebkitUserDrag: "none",
        "&[data-dragging]": {
          touchAction: "none",
          pointerEvents: "none",
        },
        "&[data-dragging] .MuiButtonBase-root:active": {
          backgroundColor: "inherit",
        },
        "&[data-dragging] .MuiButtonBase-root:active::before": {
          backgroundColor: "transparent",
        },
      }}
      data-dragging={isDragging || undefined}
    >
      {children}
    </Box>
  );
};

export default SortableItem;
